/**
 * The sidebar's footer (2.7, plan D1/D2). On a desktop, the Guest / account chip and the creator's credit used to
 * float over the page (position: fixed), on top of the last tabs, their badges and the ticker. In the game they now
 * sit at the bottom of the sidebar, in the page flow, out of the way. Phones keep them as small corner labels, and
 * outside the game (the login screen) nothing moves: they go back exactly where they were.
 */
const SF_DESK = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(min-width: 761px)") : null;

function sfPlace() {
  const dash = document.getElementById("dashboard-screen");
  const sidebar = dash && dash.querySelector(".sidebar");
  if (!sidebar) return;
  let foot = sidebar.querySelector(":scope > .sidebar-foot");
  if (!foot) {
    foot = document.createElement("div");
    foot.className = "sidebar-foot";
    sidebar.appendChild(foot);
  }
  const inGame = !dash.classList.contains("hidden") && !!(SF_DESK && SF_DESK.matches);
  const chip = document.getElementById("account-chip") || document.getElementById("guest-chip");
  const credit = document.querySelector(".made-by");
  for (const el of [chip, credit]) {
    if (!el) continue;
    const home = inGame ? foot : document.body;
    if (el.parentElement !== home) home.appendChild(el);
  }
}

if (typeof window !== "undefined" && typeof document !== "undefined" && typeof MutationObserver !== "undefined") {
  const start = () => {
    sfPlace();
    // the chips are created after sign-in, and the game screen shows and hides: place them again each time
    new MutationObserver(() => sfPlace()).observe(document.body, { childList: true });
    const dash = document.getElementById("dashboard-screen");
    if (dash) new MutationObserver(() => sfPlace()).observe(dash, { attributes: true, attributeFilter: ["class"] });
    if (SF_DESK && SF_DESK.addEventListener) SF_DESK.addEventListener("change", sfPlace);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
}

export { sfPlace };
